import { render, staticRenderFns } from "./recipientInfo.vue?vue&type=template&id=41697d73"
import script from "./recipientInfo.vue?vue&type=script&lang=js"
export * from "./recipientInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports